import { getData, postData, convertPageModel } from './api-base.service'

export const getVACoursePageData = (model) => {
  let data = convertPageModel(model);

  let result = postData(`/VideoAppointment/GetVACoursePageData`, data);
  return result;
}

export const getVideoAppointmentList = (model) => {
  let data = convertPageModel(model);

  let result = postData(`/VideoAppointment/GetVideoAppointmentList`, data);
  return result;
}

export const getVideoAppointment = (id) => {
  let data = { id: id };
  let result = getData('/VideoAppointment/GetVideoAppointment', data);
  return result;
}

export const cancelVideoAppointment = (id) => {
  let data = { id: id };
  let result = getData('/VideoAppointment/CancelVideoAppointment', data);
  return result;
}

export const getCurrentVideoAppoint = (videoAppointmentId, courseActivationId) => {
  let data = { videoAppointmentId: videoAppointmentId, courseActivationId: courseActivationId };
  let result = getData('/VideoAppointment/GetCurrentVideoAppoint', data);
  return result;
}

export const checkIsWatchApproved = (id) => {
  let result = getData('/VideoAppointment/CheckIsWatchApproved', {id: id});
  return result;
}


export const updateWatchSeconds = (videoAppointmentId, courseActivationId, seconds, isUseTermFreeCount) => {
  let data = { videoAppointmentId: videoAppointmentId,
    courseActivationId: courseActivationId,
    seconds: seconds,
    isUseTermFreeCount: isUseTermFreeCount
  };
  let result = getData('/VideoAppointment/UpdateWatchSeconds', data);
  return result;
}

export const getVideoAppointmentPrice = () => {
  let result = getData(`/VideoAppointment/GetVideoAppointmentPrice`);
  return result;
}

export const savePayment = (id, price, balanceCost, bonusPointCost, bonusPointPrice) => {
  let data = {
    Id: id,
    Price: price,
    BalanceCost: balanceCost,
    BonusPointCost:bonusPointCost,
    BonusPointPrice: bonusPointPrice
  }
  let result = postData('/VideoAppointment/SaveVideoSitePayment', data);
  return result;
}

export const getWatchHistory = (courseActivationId) => {
  let data = {courseActivationId: courseActivationId};
  let result = getData(`/VideoAppointment/GetWatchHistory`, data);
  return result;
}

export const checkOnlineCourse = (courseActivationId) => {
  let data = {courseActivationId: courseActivationId};
  let result = getData(`/VideoAppointment/CheckOnlineCourse`, data);
  return result;
}

export const validateVideoAppointmentToken = (videoAppointmentId, token) => {
  let data = {videoAppointmentId: videoAppointmentId, token: token};
  return getData(`/VideoAppointment/ValidateVideoAppointmentToken`, data);
}

export const generateAppointmentToken = (videoAppointmentId) => {
  let data = {videoAppointmentId: videoAppointmentId};
  return getData(`/VideoAppointment/GenerateAppointmentToken`, data);
}


// WEBPACK FOOTER //
// ./src/service/videoAppointment.service.js